var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpam = function SvgSpam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M.313 6a5.687 5.687 0 1 1 11.374 0A5.687 5.687 0 0 1 .313 6M6 3.813a.437.437 0 0 1 .438.437v2.188a.437.437 0 1 1-.875 0V4.25A.437.437 0 0 1 6 3.813m0 4.812a.437.437 0 1 0 0-.875.437.437 0 0 0 0 .875",
    clipRule: "evenodd"
  })));
};
export default SvgSpam;